/* Site-Specific JavaScript */

// Quick links: mark the link that matches the current page as active
(function () {
    var normalize = function (path) {
        path = (path || '').replace(/\/+$/, '');
        return path === '' ? '/' : path;
    };
    var current = normalize(window.location.pathname);
    document.querySelectorAll('.module-quick-links li > a[href]').forEach(function (link) {
        var target;
        try {
            target = new URL(link.getAttribute('href'), window.location.origin);
        } catch (err) {
            return;
        }
        if (target.origin !== window.location.origin) {
            return;
        }
        if (normalize(target.pathname) === current) {
            link.parentElement.classList.add('active');
            link.setAttribute('aria-current', 'page');
        }
    });


})();


const remediateFaultyAriaLabels = () => {
    jq(`
        .charter-link,
        .module-asset-list > .asset > a,
        .headline-link[aria-label]
    `).each(function () {
        const ariaLabel = (jq(this).attr('aria-label') || '').trim();
        if (!ariaLabel) {
            return;
        }
        jq(this).find('span').each(function () {
            jq(this).attr('aria-hidden', 'true');
        })
        const srOnlySpan = document.createElement('span');
        srOnlySpan.classList.add('visually-hidden');
        srOnlySpan.textContent = ariaLabel;
        jq(this).prepend(srOnlySpan);
        jq(this).removeAttr('aria-label');
    });
}

jq(document).ready(function () {
    remediateFaultyAriaLabels();
});